// ─── Cidades por estado ───
export const ESTADOS_CIDADES = {
  SP: ['São Paulo','Campinas','Santos','Sorocaba','Guarulhos','Ribeirão Preto','São José dos Campos','Osasco'],
  RJ: ['Rio de Janeiro','Niterói','Petrópolis','Nova Iguaçu','Duque de Caxias'],
  MG: ['Belo Horizonte','Uberlândia','Contagem','Juiz de Fora','Betim'],
  RS: ['Porto Alegre','Caxias do Sul','Gramado','Canoas','Pelotas'],
  PR: ['Curitiba','Londrina','Maringá','Cascavel'],
  SC: ['Florianópolis','Joinville','Blumenau','Balneário Camboriú'],
  BA: ['Salvador','Feira de Santana','Porto Seguro'],
  PE: ['Recife','Olinda','Caruaru','Jaboatão'],
  CE: ['Fortaleza','Caucaia','Sobral'],
  GO: ['Goiânia','Aparecida de Goiânia','Anápolis'],
  DF: ['Brasília','Águas Claras','Taguatinga','Ceilândia'],
  ES: ['Vitória','Vila Velha','Serra'],
  PA: ['Belém','Ananindeua'],
  MA: ['São Luís','Imperatriz'],
  MT: ['Cuiabá','Rondonópolis'],
  MS: ['Campo Grande','Dourados'],
  AM: ['Manaus'],
  RN: ['Natal','Mossoró'],
  PB: ['João Pessoa','Campina Grande'],
  AL: ['Maceió','Arapiraca'],
  SE: ['Aracaju'],
  PI: ['Teresina'],
};

export const UFS = Object.keys(ESTADOS_CIDADES);

export const TIPOS = ['Apartamento','Casa','Terreno','Comercial','Galpão','Chácara','Cobertura','Sobrado'];

// Filter options — each entry's `code` must match a modalidade value stored
// in the properties table exactly (that's what the API compares against).
// 1ª Praça / 2ª Praça are NOT included: the Caixa CSV doesn't distinguish
// auction rounds (they share the bucket "Leilão SFI - Edital Único") and
// pulling them would require a dedicated detail-page scraper for auction
// phase + date per-round. Happy to add later if asked.
export const MODALIDADES = [
  { code: 'Venda Online',              label: 'Venda Online' },
  { code: 'Venda Direta Online',       label: 'Venda Direta Online' },
  { code: 'Leilão SFI - Edital Único', label: 'Leilão SFI' },
  { code: 'Licitação Aberta',          label: 'Licitação Aberta' },
  { code: 'Leilão',                    label: 'Leilão (Santander)' },
];

export const BANCOS = ['Caixa','Santander'];

// Short-form filter keys used by App state (compact URL) vs. long-form keys
// expected by the backend saved_filters + properties list endpoints.
export const FILTER_KEY_MAP = {
  uf: 'uf', ci: 'cidade', tp: 'tipo', bk: 'banco', md: 'modalidade',
  pm: 'precoMin', px: 'precoMax', qm: 'quartos', cd: 'formaPagamento',
  nr: 'nivelRisco',
};
export const FILTER_KEY_MAP_REVERSE = Object.fromEntries(
  Object.entries(FILTER_KEY_MAP).map(([k, v]) => [v, k]),
);

// Filter options that map to the Caixa `formas_pagamento` codes. Santander
// only accepts "À Vista" so that filter also matches all Santander listings.
export const FORMAS_PAGAMENTO = [
  { code: 'proprios',     label: 'À Vista' },
  { code: 'habitacional', label: 'Financiamento' },
  { code: 'fgts',         label: 'FGTS' },
];

// Risk levels — match the codes produced by backend/lib/riskAnalyzer.ts.
// Keep the labels accent-aware; the API filter matches on the code.
export const NIVEIS_RISCO = [
  { code: 'baixo',     label: 'Risco baixo' },
  { code: 'medio',     label: 'Risco médio' },
  { code: 'alto',      label: 'Risco alto' },
  { code: 'altissimo', label: 'Risco altíssimo' },
];

export const RUAS = [
  'Rua das Flores','Av. Brasil','Alameda Santos','Av. Paulista',
  'Rua XV de Novembro','Av. Beira Mar','Rua do Porto','Av. Atlântica',
];

// ─── Formatação ───
export const formatBRL = (v) => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export const formatDate = (d) => {
  if (!d) return '—';
  const dt = new Date(d);
  return isNaN(dt.getTime()) ? '—' : dt.toLocaleDateString('pt-BR');
};
